import { createAction, props } from '@ngrx/store';
import { IAssetsState } from './assets.state';

export const initAssetsAction = createAction('[Assets Page] Assets page');

export const setAssetsAction = createAction(
  '[Assets Page] set data',
  props<IAssetsState>()
);
